import Mock from './mock';
import { getEnv } from 'ecx.saigon.ui.common';
import { getLeases as query } from '../graphql/lease';
import apolloClient from '../../utils/apollo-client';

export default async function getLeases() {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.getLeases;
  }

  const response = await apolloClient().then((client) =>
    client.query({
      query
    })
  );
  return response.data.getLeases;
}
